import { Map } from 'immutable';

import * as t from '../../actions/accountSettingsActionTypes';

const initialState = Map({
  rates: [],
  possibleCyclesForUser: [],
  loadingUserSubscription: false,
  userSubscription: null,
  editPaymentDetailsWaiting: false,
  editPaymentDetailsSuccess: false,
  editPaymentDetailsMessage: { type: 'success', text: '' },
  customerMessage: { type: 'success', text: '' },
  customerSiteMockUp: {},
  questionNotification: {
    id: null,
    idType: null,
  },
  coupon: {},
  applyCouponMessage: {},
  loadCoupon: false,
  studySpeedSettingsMessage: {
    type: '',
    message: '',
  },
  isLoadingStudySpeedSettings: false,
  flashChoose: { value: true, typeChoose: '' },
  possibleCyclesForUpdateExam: [],
  customSync: null,
  customSyncMessage: { type: '', message: '' },
  isLoadingCustomSync: false,
  isLoadingCustomSyncData: true,
});

const reducer = function mainAccountSettingsReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case t.GET_CUSTOM_SYNC:
      return state.set('isLoadingCustomSyncData', true);
    case t.SET_ALL_RATES:
      return state.set('rates', action.rates);
    case t.SET_POSSIBLE_CYCLES_FOR_USER:
      return state.set('possibleCyclesForUser', action.cycles);
    case t.SET_USER_SUBSCRIPTION:
      return state.set('userSubscription', action.subscription);
    case t.SET_LOADING_SUBSCRIPTION:
      return state.set('loadingUserSubscription', action.value);
    case t.SET_EDIT_PAYMENT_DETAILS_MESSAGE:
      return state.set('editPaymentDetailsMessage', action.message);
    case t.SET_EDIT_PAYMENT_DETAILS_WAITING:
      return state.set('editPaymentDetailsWaiting', action.value);
    case t.SET_EDIT_PAYMENT_DETAILS_SUCCESS:
      return state.set('editPaymentDetailsSuccess', action.value);
    case t.SET_CUSTOMER_MESSAGE:
      return state.set('customerMessage', action.message);
    case t.SET_CUSTOMER_SITE_MOCK_UP:
      return state.set('customerSiteMockUp', action.customer);
    case t.SET_QUESTION_NOTIFICATION:
      return state.set('questionNotification', {
        id: action.id,
        idType: action.idType,
      });
    case t.SET_LAST_COUPON_USER:
      return state.set('coupon', action.coupon);
    case t.SET_APPLY_COUPON_MESSAGE:
      return state.set('applyCouponMessage', action.message);
    case t.LOAD_APPLY_COUPON:
      return state.set('loadCoupon', action.status);
    case t.SET_STUDY_SPEED_SETTINGS_MESSAGE:
      return state.set('studySpeedSettingsMessage', action.message);
    case t.SET_IS_LOADING_STUDY_SPEED_SETTINGS:
      return state.set('isLoadingStudySpeedSettings', action.status);
    case t.SET_AVAILABLE_QUALS_FOR_DAILY_QUIZ:
      return state.set('availableQualsForDailyQuiz', action.quals);
    case t.SET_FLASH_SECTION_CHOOSE:
      return state.set('flashChoose', action.value);
    case t.SET_POSSIBLE_CYCLES_FOR_UPDATE_EXAM:
      return state.set('possibleCyclesForUpdateExam', action.cycles);
    case t.SET_CUSTOM_SYNC:
      return state.set('customSync', action.customSync);
    case t.SET_CUSTOM_SYNC_MESSAGE:
      return state.set('customSyncMessage', action.message);
    case t.SET_IS_LOADING_CUSTOM_SYNC:
      return state.set('isLoadingCustomSync', action.status);
    case t.SET_IS_LOADING_CUSTOM_SYNC_DATA:
      return state.set('isLoadingCustomSyncData', action.status);

    default:
      return state;
  }
};

export default reducer;
